var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer flex flex-row font-koho text-customRed text-sm"},[_vm._v(" "+_vm._s(_vm.countDown)+" seconds ")])}
var staticRenderFns = []

export { render, staticRenderFns }